export default __webpack_public_path__ + "static/media/dotnet-core.e2aac1c9.svg";